import React from 'react';
import "normalize.css";
import "./src/styles/global.scss";

import { StateProvider } from './src/contexts/StateContext';

export const wrapRootElement = ({ element }) => (
  <StateProvider>
    {element}
  </StateProvider>
);
